import { render, staticRenderFns } from "./ImsDatepicker.vue?vue&type=template&id=130489ae"
import script from "./ImsDatepicker.vue?vue&type=script&lang=js"
export * from "./ImsDatepicker.vue?vue&type=script&lang=js"
import style0 from "./ImsDatepicker.vue?vue&type=style&index=0&id=130489ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports